/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $insertNodeToNearestRoot } from '@lexical/utils';
import {
  COMMAND_PRIORITY_EDITOR,
  createCommand,
  LexicalCommand,
} from 'lexical';
import { type JSX, useEffect } from 'react';
import {
  $createEmbedCodeNode,
  EmbedCodeNode,
} from '@/components/LexicalEditor/nodes/EmbedCodeNode';

export const INSERT_CODE_COMMAND: LexicalCommand<string> = createCommand(
  'INSERT_CODE_COMMAND',
);

export default function EmbedCodePlugin(): JSX.Element | null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!editor.hasNodes([EmbedCodeNode])) {
      throw new Error('EmbedCodePlugin: CodeNode not registered on editor');
    }

    return editor.registerCommand<string>(
      INSERT_CODE_COMMAND,
      (payload) => {
        console.log('payload', payload);
        const embedCodeNode = $createEmbedCodeNode(payload);
        $insertNodeToNearestRoot(embedCodeNode);

        return true;
      },
      COMMAND_PRIORITY_EDITOR,
    );
  }, [editor]);

  return null;
}
